<template>
  <div>
    <div>
      <b-button size="sm" variant="info" class="mr-1 reset-button" @click="resetSettings()">{{ $t('settings.reset') }}</b-button>
    </div>
    <b-table v-if="userStore.isShipsLoaded && this.routesStore.getShipIndex !== -1" style="overflow-x: hidden" sticky-header="520px" size="sm" thead-class="d-none" :items="items()" :fields="visible_fields">
      <template v-slot:cell(value)="row">
<!--        <b-row v-if="row.item.name === 'Name'">-->
<!--          <b-col cols="3"></b-col>-->
<!--          <b-col>-->
<!--            <b-form-input type="text" v-model="curSettings.name"/>-->
<!--          </b-col>-->
<!--        </b-row>-->

        <b-row v-if="row.item.name === $t('settings.nogo')">
          <b-col cols="3">{{ curSettings.nogo }}</b-col>
          <b-col>
            <b-form-input type="range" :min="curSettings.draught" step="0.2" max="25" v-model="curSettings.nogo"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.draught')">
          <b-col cols="3">{{ curSettings.draught }}</b-col>
          <b-col>
            <b-form-input type="range" min="1" step="0.2" max="25" v-model="curSettings.draught"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.height')">
          <b-col cols="3">{{ curSettings.height }}</b-col>
          <b-col>
            <b-form-input type="range" min="1" step="0.2" max="50" v-model="curSettings.height"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.length')">
          <b-col cols="3">{{ curSettings.length }}</b-col>
          <b-col>
            <b-form-input type="range" min="2" step="1" max="200" v-model="curSettings.length"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.width')">
          <b-col cols="3">{{ curSettings.width }}</b-col>
          <b-col>
            <b-form-input type="range" min="1" step="1" max="100" v-model="curSettings.width"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.displacement')">
          <b-col cols="3">{{ curSettings.displacement }}</b-col>
          <b-col>
            <b-form-input type="range" min="100" step="100" max="80000" v-model="curSettings.displacement"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.radius')">
          <b-col cols="3">{{ curSettings.radius }}</b-col>
          <b-col>
            <b-form-input type="range" min="10" step="10" max="500" v-model="curSettings.radius"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.xtl')">
          <b-col cols="3">{{ curSettings.xtel }}</b-col>
          <b-col>
            <b-form-input type="range" min="10" step="10" max="3000" v-model="curSettings.xtel"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.xtr')">
          <b-col cols="3">{{ curSettings.xter }}</b-col>
          <b-col>
            <b-form-input type="range" min="10" step="10" max="3000" v-model="curSettings.xter"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.speed')">
          <b-col cols="3">{{ curSettings.speed }}</b-col>
          <b-col>
            <b-form-input type="range" min="1" step="1" max="50" v-model="curSettings.speed"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.trackRatio')">
          <b-col cols="3">{{ curSettings.trackratio }}</b-col>
          <b-col>
            <b-form-input type="range" min="0.1" step="0.1" max="0.9" v-model="curSettings.trackratio"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.shallowRatio')">
          <b-col cols="3">{{ curSettings.shallowratio }}</b-col>
          <b-col>
            <b-form-input type="range" min="1" step="0.5" max="10" v-model="curSettings.shallowratio"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.avoidShallowStrength')">
          <b-col cols="3">{{ curSettings.avoidshallowstrength }}</b-col>
          <b-col>
            <b-form-input type="range" min="1" step="0.5" max="10" v-model="curSettings.avoidshallowstrength"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.avoidDistance')">
          <b-col cols="3">{{ curSettings.avoiddistance }}</b-col>
          <b-col>
            <b-form-input type="range" min="0" step="10" max="3000" v-model="curSettings.avoiddistance"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.refineCoeff')">
          <b-col cols="3">{{ curSettings.refinecoefficient }}</b-col>
          <b-col>
            <b-form-input type="range" min="1" step="1" max="15" v-model="curSettings.refinecoefficient"/>
          </b-col>
        </b-row>

        <b-form-input type="date" v-if="row.item.name === $t('settings.startDate')" v-model="curSettings.startdate"/>

        <b-form-input type="time" v-if="row.item.name === $t('settings.startTime')" v-model="curSettings.starttime"/>

        <b-form-checkbox v-if="row.item.name === $t('settings.allowSuez')" v-model="curSettings.usesuez"/>

        <b-form-checkbox v-if="row.item.name === $t('settings.allowPanama')" v-model="curSettings.usepanama"/>

        <b-form-checkbox v-if="row.item.name === $t('settings.allowBering')" v-model="curSettings.usebering"/>

        <b-form-checkbox v-if="row.item.name === $t('settings.allowRivers')" v-model="curSettings.userivers"/>

        <b-form-checkbox v-if="row.item.name === $t('settings.recommendedTracks')" v-model="curSettings.userecommendedtracks"/>

        <b-form-checkbox v-if="row.item.name === $t('settings.generalRoutes')" v-model="curSettings.usegeneralroutes"/>

        <b-form-checkbox v-if="row.item.name === $t('settings.tiles')" v-model="curSettings.usegoodtiles"/>
      
        <b-row v-if="row.item.name === $t('settings.graphRouteScoreFactor')">
          <b-col cols="3">{{ curSettings.graphRouteScoreFactor }}</b-col>
          <b-col>
            <b-form-input type="range" min="0.1" step="0.1" max="2" v-model="curSettings.graphRouteScoreFactor"/>
          </b-col>
        </b-row>
        
        <b-row v-if="row.item.name === $t('settings.landAroundScoreFactor')">
          <b-col cols="3">{{ curSettings.landAroundScoreFactor }}</b-col>
          <b-col>
            <b-form-input type="range" min="0.1" step="0.1" max="4" v-model="curSettings.landAroundScoreFactor"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.waterScoreFactor')">
          <b-col cols="3">{{ curSettings.waterScoreFactor }}</b-col>
          <b-col>
            <b-form-input type="range" min="0.1" step="0.1" max="2" v-model="curSettings.waterScoreFactor"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.nearestPointsNumber')">
          <b-col cols="3">{{ curSettings.nearestPointsNumber }}</b-col>
          <b-col>
            <b-form-input type="range" min="1" step="1" max="40" v-model="curSettings.nearestPointsNumber"/>
          </b-col>
        </b-row>

        <b-row v-if="row.item.name === $t('settings.linkHeuristicFactor')">
          <b-col cols="3">{{ curSettings.linkHeuristicFactor }}</b-col>
          <b-col>
            <b-form-input type="range" min="0.8" step="0.1" max="2" v-model="curSettings.linkHeuristicFactor"/>
          </b-col>
        </b-row>        

        <b-form-checkbox v-if="row.item.name === $t('settings.previewLandContour')" v-model="curSettings.previewLandContour"/>
        <b-form-checkbox v-if="row.item.name === $t('settings.graphDiag')" v-model="curSettings.graphDiag"/>

      </template>
    </b-table>

  </div>
</template>

<script>
import {eventBus, routes_map} from "@/main";
import {useRoutesStore} from "@/stores/routes";
import {mapStores} from "pinia";
import {debounce} from 'vue2-debounce'
import dayjs from "dayjs";
import {useUserStore} from "@/stores/user";

export default {
  data() {
    return {
      debounceDepth: {
        isDebounced: false,
      },
      debounceTiles: {
        isDebounced: false,
      },
      x: ''
    }
  },
  watch: {
    'curSettings.draught'(newVal) {
      if (Number(newVal) > Number(this.curSettings.nogo))
        this.curSettings.nogo = newVal

      // if (!this.debounceDepth.isDebounced) {
      //   this.debounceDepth.isDebounced = true
      //   debounce(val => this.redrawNoGo(val), 2000)(newVal)
      // }

      this.graphRelatedSettingsChanged();
    },
    'curSettings.usegoodtiles'(newVal) {
      if (newVal !== this.curSettings.usegoodtiles)
        this.curSettings.usegoodtiles = newVal

      if (!this.debounceDepth.isDebounced) {
        this.debounceTiles.isDebounced = true
        debounce(val => this.redrawTiles(val), 2000)(newVal)
      }
    },
    'curSettings.nogo'(newVal) {
      if (!this.debounceDepth.isDebounced) {
        this.debounceDepth.isDebounced = true
        debounce(val => this.redrawNoGo(val), 2000)(newVal)
      }
      this.graphRelatedSettingsChanged();
    },
    'curSettings.xtel'() {
      eventBus.$emit('xte-changed')
    },
    'curSettings.xter'() {
      eventBus.$emit('xte-changed')
    },
    'curSettings.startdate'() {
      eventBus.$emit('route-datetime-changed')
    },
    'curSettings.starttime'() {
      eventBus.$emit('route-datetime-changed')
    },   
    'curSettings.length'() {
      this.graphRelatedSettingsChanged();
    },    
    'curSettings.width'() {
      this.graphRelatedSettingsChanged();
    },
    'curSettings.height'() {
      this.graphRelatedSettingsChanged();
    },
    'curSettings.graphRouteScoreFactor'() {
      this.graphRelatedSettingsChanged();
    },
    'curSettings.landAroundScoreFactor'() {
      this.graphRelatedSettingsChanged();
    },
    'curSettings.linkHeuristicFactor'() {
      this.graphRelatedSettingsChanged();
    },    
    'curSettings.waterScoreFactor'() {
      this.graphRelatedSettingsChanged();
    },
    'curSettings.nearestPointsNumber'() {
      this.graphRelatedSettingsChanged();
    },
    'curSettings.previewLandContour'() {
      this.graphRelatedSettingsChanged();
    },
    'curSettings.graphDiag'() {
      eventBus.$emit('graph-diag-changed');
    },
  },
  mounted() {
    // let now = dayjs()
    // this.routesStore.addRouteDate(dayjs(now).format("YYYY-MM-DD"))
    // this.routesStore.addRouteTime(dayjs(now).format("HH:mm:ss"))
  },
  beforeDestroy() {
  },
  computed: {
    ...mapStores(useRoutesStore, useUserStore),
    curIndex(){
      return this.routesStore.getShipIndex
    },
    curSettings(){
      return this.routesStore.routes[this.curIndex]?.routeSettings
    },
    visible_fields() {
      return [
        {key: 'name', label: 'Settings', tdClass: 'small-black', thClass: 'small-gray'},
        {key: 'value', label: 'Values', tdClass: 'small-black', thClass: 'small-gray'},
      ]
    }
  },
  methods: {
    resetSettings() {
      const settings = this.curSettings;

      settings.nogo = "7",
      settings.draught = "5",
      settings.length = "120",
      settings.width = "20",
      settings.height = "20",
      settings.radius = "120",
      settings.displacement = "8000",
      settings.xtel = "120",
      settings.xter = "120",
      settings.speed = "10",
      settings.trackratio = "0.7",
      settings.shallowratio = "1",
      settings.avoidshallowstrength = "1",
      settings.avoiddistance = "550",
      settings.refinecoefficient = "1",
      settings.userecommendedtracks = true,
      settings.usegeneralroutes = true,
      settings.usesuez = true,
      settings.usepanama = true,
      settings.usebering = true,
      settings.userivers = false,
      settings.usegoodtiles = false,
      settings.graphRouteScoreFactor = 0.8,
      settings.landAroundScoreFactor = 1.7,
      settings.waterScoreFactor = 1,
      settings.nearestPointsNumber = 30,
      settings.previewLandContour = false,
      settings.linkHeuristicFactor = 1,
      settings.graphDiag = false;

      this.graphRelatedSettingsChanged();
    },
    graphRelatedSettingsChanged() {
      eventBus.$emit('graph-related-settings-changed')
    },
    items() {
      const isDevBuild = routes_map.isDevBuild();

      return [
        // {name: 'Name', value: this.curSettings?.name},
        {name: this.$t('settings.nogo'), value: this.curSettings?.nogo},
        {name: this.$t('settings.draught'), value: this.curSettings?.draught},
        {name: this.$t('settings.height'), value: this.curSettings?.height},
        {name: this.$t('settings.length'), value: this.curSettings?.length},
        {name: this.$t('settings.width'), value: this.curSettings?.width},
        {name: this.$t('settings.displacement'), value: this.curSettings?.displacement},
        {name: this.$t('settings.radius'), value: this.curSettings?.radius},
        {name: this.$t('settings.xtl'), value: this.curSettings?.xtel},
        {name: this.$t('settings.xtr'), value: this.curSettings?.xter},
        {name: this.$t('settings.speed'), value: this.curSettings?.speed},
        {name: this.$t('settings.trackRatio'), value: this.curSettings?.trackratio},
        {name: this.$t('settings.shallowRatio'), value: this.curSettings?.shallowratio},
        {name: this.$t('settings.avoidShallowStrength'), value: this.curSettings?.avoidshallowstrength},
        {name: this.$t('settings.avoidDistance'), value: this.curSettings?.avoiddistance},
        {name: this.$t('settings.refineCoeff'), value: this.curSettings?.refinecoefficient},
        {name: this.$t('settings.startDate'), value: this.curSettings?.startdate},
        {name: this.$t('settings.startTime'), value: this.curSettings?.starttime},
        {name: this.$t('settings.allowSuez'), value: this.curSettings?.usesuez},
        {name: this.$t('settings.allowPanama'), value: this.curSettings?.usepanama},
        {name: this.$t('settings.allowBering'), value: this.curSettings?.usebering},
        {name: this.$t('settings.allowRivers'), value: this.curSettings?.userivers},
        {name: this.$t('settings.recommendedTracks'), value: this.curSettings?.userecommendedtracks},
        {name: this.$t('settings.generalRoutes'), value: this.curSettings?.usegeneralroutes},
        {name: this.$t('settings.tiles'), value: this.curSettings?.usegoodtiles},
        ...(
          isDevBuild
          ? [
              {name: this.$t('settings.graphRouteScoreFactor'), value: this.curSettings?.graphRouteScoreFactor},
              {name: this.$t('settings.landAroundScoreFactor'), value: this.curSettings?.landAroundScoreFactor},
              {name: this.$t('settings.waterScoreFactor'), value: this.curSettings?.waterScoreFactor},
              {name: this.$t('settings.linkHeuristicFactor'), value: this.curSettings?.linkHeuristicFactor},
              {name: this.$t('settings.previewLandContour'), value: this.curSettings?.previewLandContour},
              {name: this.$t('settings.nearestPointsNumber'), value: this.curSettings?.nearestPointsNumber},
              {name: this.$t('settings.graphDiag'), value: this.curSettings?.graphDiag},
            ] 
          : []
        )
      ]
    },
    redrawNoGo(val) {
      this.debounceDepth.isDebounced = false
      routes_map.addNoGoLayer()
    },
    redrawTiles(val) {
      this.debounceTiles.isDebounced = false

      // eventBus.$emit('remove-primar-tiles')
      // setTimeout(() => {
      //   eventBus.$emit('restore-primar-tiles')
      // }, 1000)


      routes_map.addNavLayer()
      routes_map.addNoGoLayer()
    }
  }
}
</script>

<style scoped>
.reset-button {
  margin-bottom: 1rem;
}
</style>